import script from "./InvoiceDataTab.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceDataTab.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceDataTab.vue?vue&type=style&index=0&id=4943a018&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4943a018"]])

export default __exports__